const HEALTH_SCORE_COLORS = {
	'At Risk': 'error.main', // red
	Stable: 'success.light', // light green
	Strong: 'success.main', // green
};

/**
 * Returns an MUI theme color path for a given health score classification.
 * Falls back to 'text.primary' for "Insufficient Data" or any unrecognized value.
 * @param {string} classification - e.g. 'At Risk', 'Stable', 'Strong'
 * @returns {string} MUI sx-compatible color string
 */
export const getHealthScoreColor = (classification) =>
	HEALTH_SCORE_COLORS[classification] || 'text.primary';
